import React, { Component } from 'react';

import marker from './marker.png';
import { minWidth, tablet } from '../../screenSizes';

export class Map extends Component {
  componentDidMount() {
    //eslint-disable-next-line no-undef
    mapboxgl.accessToken =
      'pk.eyJ1Ijoic3R5cmVsc2VuLXNpdGUiLCJhIjoiY2pmam83eWMwNnEwNTM0cGQwMjVjcW11ZSJ9.hLzH5IvHREoFDPHvXI_Ikg';
    /* Map: This represents the map on the page. */
    //eslint-disable-next-line no-undef
    const map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/light-v9',
      zoom: 15.9,
      center: [18.044, 59.3288],
    });

    map.on('load', function() {
      /* Image: An image is loaded and added to the map. */
      map.loadImage(marker, function(error, image) {
        if (error) throw error;
        map.addImage('custom-marker', image);
        /* Style layer: A style layer ties together the source and image and specifies how they are displayed on the map. */
        map.addLayer({
          id: 'markers',
          type: 'symbol',
          /* Source: A data source specifies the geographic coordinate where the image marker gets placed. */
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: [
                {
                  type: 'Feature',
                  geometry: {
                    type: 'Point',
                    coordinates: ['18.044', '59.3288'],
                  },
                },
              ],
            },
          },
          layout: {
            'icon-image': 'custom-marker',
            'icon-size': 0.75,
          },
        });
      });
    });
  }

  render() {
    return (
      <div
        id="map"
        css={`
          min-height: 300px;
          border-top: 1px solid #444;

          ${minWidth(tablet)} {
            min-height: 400px;
          }
        `}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ContactSection/Map.js